import { IconType, SvgIcon } from './SvgIcon';

export const ClockIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M9.9974 18.8332C14.5998 18.8332 18.3307 15.1022 18.3307 10.4998C18.3307 5.89746 14.5998 2.1665 9.9974 2.1665C5.39502 2.1665 1.66406 5.89746 1.66406 10.4998C1.66406 15.1022 5.39502 18.8332 9.9974 18.8332Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5.5V10.5L13.3333 12.1667"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

ClockIcon.displayName = 'ClockIcon';
